<template>
  <div class="hrm_input" v-if="filterItem?.location?.showLocation">
    <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
      {{ filterItem?.location?.label }}
      <span class="text-base font-bold text-red-600" v-if="filterItem?.location?.required">*</span>
    </label>
    <div class="relative mt-2">
      <VueMultiselect class="hrm-vuemultiselect hrm_input_field" v-model="filterData[filterItem.location.models]"
        :options="filterItem?.location?.options" @select="onChangeLocation" @clear="onClearLocation"
        :placeholder="trans('lang.labels.Select')" label="location_name" valueProp="id" :searchable="true" />
    </div>
    <span v-if="errors && errors?.[filterItem.location.models]" class="mt-2 text-xs text-red-600 theme-error-message">{{
      errors[filterItem.location.models][0] }}</span>
  </div>
  <div class="theme-input hrm_input" v-if="filterItem?.department?.showDepartment">
    <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
      {{ filterItem?.department?.label }}
      <span class="text-base font-bold text-red-600" v-if="filterItem?.department?.required">*</span>
    </label>
    <div class="relative mt-2">
      <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData[filterItem.department.models]"
        @select="onChangeDepartment" @clear="onClearDepartment" :options="filterItem?.department?.options"
        :placeholder="trans('lang.labels.Select')" label="department_name" valueProp="id" :searchable="true" />
    </div>
    <span v-if="errors && errors?.[filterItem.department.models]"
      class="mt-2 text-xs text-red-600 theme-error-message">{{ errors[filterItem.department.models][0] }}</span>
  </div>
  <div class="theme-input hrm_input" v-if="filterItem?.designation?.showDesignation">
    <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
      {{ filterItem?.designation?.label }}
      <span class="text-base font-bold text-red-600" v-if="filterItem?.designation?.required">*</span>
    </label>
    <div class="relative mt-2">
      <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData[filterItem.designation.models]"
        :options="filterItem?.designation?.options" :placeholder="trans('lang.labels.Select')" label="name"
        valueProp="id" :searchable="true" @select="onChangeDesignation" @clear="onClearDesignation" />
    </div>
    <span v-if="errors && errors?.[filterItem.designation.models]"
      class="mt-2 text-xs text-red-600 theme-error-message">{{ errors[filterItem.designation.models][0] }}</span>
  </div>
  <div class="theme-input hrm_input" v-if="filterItem?.employee?.showEmployee">
    <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
      {{ filterItem?.employee?.label }}
      <span class="text-base font-bold text-red-600" v-if="filterItem?.employee?.required">*</span>
    </label>
    <div class="relative mt-2">
      <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData[filterItem.employee.models]"
        :options="filterItem?.employee?.options" :placeholder="trans('lang.labels.Select')" label="Name"
        :valueProp="filterItem.employee.itemValue ?? 'id'" :searchable="true" @clear="onClearEmployee" />
    </div>
    <span v-if="errors && errors?.employee_id" class="mt-2 text-xs text-red-600 theme-error-message">{{
      errors.employee_id[0] }}</span>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import VueMultiselect from "@vueform/multiselect";
import { useAppStore } from "@/store/index";

const appStore = useAppStore();
const props = defineProps({
  filterItem: { type: Object },
  filterData: { type: Object, required: true },
  errors: { type: Object },
});

const queryData = ref({
  perPage: "all",
  status: 1,
});
const componentKey = ref(1);

const onClearLocation = () => {
  props.filterData[props.filterItem?.location?.models] = null;
  props.filterData[props.filterItem?.department?.models] = null;
  props.filterData[props.filterItem?.designation?.models] = null;
  props.filterData[props.filterItem?.employee?.models] = null;
  componentKey.value += 1;
  if (props.filterItem?.designation?.showDesignation) {
    getDesignations(null);
  }

  if (props.filterItem?.employee?.showEmployee) {
    getDepartments(null);
  }

  if (props.filterItem?.employee?.showEmployee) {
    getEmployees();
  }
};

const onClearDepartment = () => {
  props.filterData[props.filterItem?.department?.models] = null;
  props.filterData[props.filterItem?.designation?.models] = null;
  props.filterData[props.filterItem?.employee?.models] = null;
  componentKey.value += 1;
  if (props.filterItem?.designation?.showDesignation) {
    getDesignations(null);
  }
  if (props.filterItem?.employee?.showEmployee) {
    getEmployees();
  }
};

const onClearDesignation = () => {
  props.filterData[props.filterItem?.designation?.models] = null;
  props.filterData[props.filterItem?.employee?.models] = null;

  if (props.filterItem?.employee?.showEmployee) {
    getEmployees();
  }
};

const onClearEmployee = () => {
  props.filterData[props.filterItem?.employee?.models] = null;
};

const onChangeLocation = async () => {
  if (props.filterItem?.department?.showDepartment) {
    await getDepartments(props.filterData[props.filterItem?.location?.models]);
  }
  if (props.filterItem?.employee?.showEmployee) {
    getEmployees();
  }
};

const onChangeDepartment = () => {
  if (props.filterItem?.designation?.showDesignation) {
    getDesignations(props.filterData[props.filterItem?.department?.models]);
  }
  if (props.filterItem?.employee?.showEmployee) {
    getEmployees();
  }
};

const onChangeDesignation = () => {
  if (props.filterItem?.employee?.showEmployee) {
    getEmployees();
  }
};

const getLocations = async (type) => {
  try {
    const response = await axios.get(route("hrm.office-locations.index"), {
      params: queryData.value,
    });
    props.filterItem.location.options = response.data.data;
    if (type == "reload") {
      appStore.locations = response.data.data;
    }
  } catch (error) {
    console.error("Error fetching locations:", error);
  }
};

const getDepartments = async (departmentId, type) => {
  queryData.value.departmentId = departmentId;
  try {
    const response = await axios.get(route("hrm.departments.index"), {
      params: queryData.value,
    });
    props.filterItem.department.options = response.data.data;
    if (type == "reload") {
      appStore.departments = response.data.data;
    }
  } catch (error) {
    console.error("Error fetching departments:", error);
  }
};

const getDesignations = (departmentId, type) => {
  queryData.value.departmentId = departmentId;
  axios
    .get(route("hrm.designations.index"), {
      params: queryData.value,
    })
    .then((response) => {
      props.filterItem.designation.options = response.data.data;
      if (type == "reload") {
        appStore.designations = response.data.data;
      }
    })
    .catch((error) => { })
    .finally(() => { });
};

const getEmployees = (type) => {
  const query = {
    ...(queryData.value ? queryData.value : {}),
    designationId: props.filterData[props.filterItem?.designation?.models] || null,
    locationId:
      props.filterData[props.filterItem?.location?.models] || null,
    departmentId:
      props.filterData[props.filterItem?.department?.models] || null,
    ...(props.filterItem?.employee?.query ? props.filterItem?.employee?.query : {}),
  }
  axios
    .get(route("employee-management.employees.index"), {
      params: query,
    })
    .then((response) => {
      props.filterItem.employee.options = response.data.data;
      if (type == "reload") {
        appStore.employees = response.data.data;
      }
    })
    .catch((error) => { })
    .finally(() => {
      componentKey.value += 1;
    });
};

onMounted(async () => {
  if (props.filterItem?.location?.showLocation) {
    if (appStore.locations && appStore.locations.length > 0) {
      props.filterItem.location.options = appStore.locations;
    } else {
      await getLocations("reload");
    }
  }
  if (props.filterItem?.department?.showDepartment) {
    if (appStore.departments && appStore.departments.length > 0) {
      props.filterItem.department.options = appStore.departments;
    } else {
      await getDepartments(null, "reload");
    }
  }
  if (props.filterItem?.designation?.showDesignation) {
    if (appStore.designations && appStore.designations.length > 0) {
      props.filterItem.designation.options = appStore.designations;
    } else {
      getDesignations(null, "reload");
    }
  }
  if (props.filterItem?.employee?.showEmployee) {
    // if (appStore.employees && appStore.employees.length > 0) {
    //   props.filterItem.employee.options = appStore.employees;
    // } else {
    getEmployees("reload");
    // }
  }
});
</script>